<template>
    <div>
        <a-form :form="form" @submit="handleSubmit">
            <a-card :bordered="false" class="header-solid h-full" :bodyStyle="{ paddingTop: 0, paddingBottom: '40px' }">
                <template #title>
                    <h5 class="mb-0">Company details</h5>
                </template>
                <a-row type="flex" :gutter="24">
                    <a-col :span="12" :lg="12" class="mb-12">
                        <a-row :gutter="[24]">
                            <a-col :span="24">
                                <a-form-item class="mb-10" label="Company Name" :colon="false">
                                    <a-input v-model="company.name" placeholder="Company Name" />
                                </a-form-item>
                            </a-col>
                            <a-col :span="24">
                                <a-form-item class="mb-10" label="Address" :colon="false">
                                    <a-textarea v-model="company.address" placeholder="Company Address" rows="3" />
                                </a-form-item>
                            </a-col>
                            <a-col :span="24">
                                <a-form-item class="mb-10" label="US DOT Number" :colon="false">
                                    <a-input v-model="company.us_dot_number" placeholder="US DOT Number" />
                                </a-form-item>
                            </a-col>
                            <a-col :span="24">
                                <a-form-item class="mb-10" label="MC Number" :colon="false">
                                    <a-input v-model="company.mc_number" placeholder="MC Number" />
                                </a-form-item>
                            </a-col>
                        </a-row>
                    </a-col>
                    <a-col :span="12" :lg="12" class="mb-12">
                        <a-row :gutter="[24]">
                            <a-col :span="24">
                                <a-card size="small" title="Company Summary" style="margin-bottom: 16px;">
                                    <p><strong>Name:</strong> {{ company.name || 'Not set' }}</p>
                                    <p><strong>Address:</strong> {{ company.address || 'Not set' }}</p>
                                    <p><strong>US DOT Number:</strong> {{ company.us_dot_number || 'Not set' }}</p>
                                    <p><strong>MC Number:</strong> {{ company.mc_number || 'Not set' }}</p>
                                    <p v-if="isEdit"><strong>ID:</strong> {{ company.id || 'Not set' }}</p>
                                    <p v-if="isEdit"><strong>Created At:</strong> {{ formatDateTime(company.created_at) }}</p>
                                </a-card>
                            </a-col>
                        </a-row>
                    </a-col>
                </a-row>
            </a-card>
            <a-button type="primary" html-type="submit" style="margin-top: 20px; margin-right: 8px;"> Submit </a-button>
            <a-button @click="handleCancel" style="margin-top: 20px;"> Cancel </a-button>
        </a-form>
        
        <!-- Register Link Section (only show when editing existing company) -->
        <a-card v-if="isEdit" :bordered="false" class="header-solid h-full" style="margin-top: 20px;" :bodyStyle="{ paddingTop: 0, paddingBottom: '40px' }">
            <template #title>
                <h5 class="mb-0">User Registration</h5>
            </template>
            <div class="register-link-section">
                <p class="mb-16">Generate a registration link for new users to join this company.</p>
                <a-button 
                    type="default" 
                    @click="showRegisterLinkPopup"
                    icon="plus"
                >
                    Generate User Registration Link
                </a-button>
            </div>
        </a-card>
        
        <!-- Register Link Popup -->
        <RegisterLinkPopup
            :visible="registerLinkPopupVisible"
            :company-id="company.id"
            @close="closeRegisterLinkPopup"
        />
    </div>
</template>

<script>
import router from "../../router/index.js";
import companyAPI from "../../api/company.js";
import moment from "moment";
import RegisterLinkPopup from "../../components/Users/RegisterLinkPopup.vue";

export default {
    components: {
        RegisterLinkPopup,
    },
    data() {
        return {
            company: {
                id: "",
                name: "",
                address: "",
                us_dot_number: "",
                mc_number: "",
                created_at: null,
            },
            companyEditData: null,
            isEdit: false,
            form: this.$form.createForm(this, { name: "editCompany" }),
            registerLinkPopupVisible: false,
        };
    },
    methods: {
        async getCompanyById(id) {
            return companyAPI.getCompanyById(id);
        },
        formatDateTime(dateTime) {
            if (!dateTime) return 'Not set';
            return moment(dateTime).format('YYYY-MM-DD HH:mm:ss');
        },
        handleSubmit(e) {
            e.preventDefault();
            this.form.validateFields((err) => {
                if (!err) {
                    // Prepare company data for submission
                    const companyData = {
                        ...this.company,
                    };

                    // Request to create or update company
                    if (!this.isEdit) {
                        companyAPI
                            .createCompany(companyData)
                            .then((responseData) => {
                                if (responseData.status == 201) {
                                    this.$message.success('Company created successfully');
                                    router.push("/companies/companies-list");
                                }
                            })
                            .catch((error) => {
                                console.error('Error creating company:', error);
                                const errorMessage = error.response?.data?.error || 'Failed to create company';
                                if (errorMessage.includes('duplicate values found')) {
                                    this.$message.error('Creation failed: ' + errorMessage);
                                } else {
                                    this.$message.error(errorMessage);
                                }
                            });
                    } else {
                        companyAPI
                            .updateCompany(companyData)
                            .then((responseData) => {
                                if (responseData.status == 200) {
                                    this.$message.success('Company updated successfully');
                                    router.push("/companies/companies-list");
                                }
                            })
                            .catch((error) => {
                                console.error('Error updating company:', error);
                                const errorMessage = error.response?.data?.error || 'Failed to update company';
                                if (errorMessage.includes('duplicate values found')) {
                                    this.$message.error('Update failed: ' + errorMessage);
                                } else {
                                    this.$message.error(errorMessage);
                                }
                            });
                    }
                }
            });
        },
        
        showRegisterLinkPopup() {
            this.registerLinkPopupVisible = true;
        },
        
        closeRegisterLinkPopup() {
            this.registerLinkPopupVisible = false;
        },
        
        handleCancel() {
            router.push("/companies/companies-list");
        },
    },
    async mounted() {
        if (this.$route.params.id !== undefined) {
            this.companyEditData = await this.getCompanyById(this.$route.params.id); // get company data according to ID
            this.isEdit = true;
                    this.company.id = this.companyEditData.id || '';
        this.company.name = this.companyEditData.name || '';
        this.company.address = this.companyEditData.address || '';
        this.company.us_dot_number = this.companyEditData.us_dot_number || '';
        this.company.mc_number = this.companyEditData.mc_number || '';
        this.company.created_at = this.companyEditData.created_at || null;
        }
    },
};
</script>

<style lang="scss" scoped>
// Company form specific styles
.ant-card {
    .ant-card-body {
        p {
            margin-bottom: 8px;
            
            strong {
                color: #1890ff;
            }
        }
    }
}
</style>
